






























































// This component fetches a list of stories and displays them as a list of StoryComponent's
import { Component, Prop, Vue } from 'vue-property-decorator';
import * as utils from '@/utils';
import { StoryUser, howJoinedTypes, likelyToBeTypes, quizSteps } from '@/StoryUser'
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

@Component({
  name: 'QuizMultipleChoiceComponent',
  components: {
    ModalWrapperComponent: () => import('@/components/ModalWrapperComponent.vue'),
    VuePhoneNumberInput: () => import('vue-phone-number-input')
  }
})
export default class QuizMultipleChoiceComponent extends Vue {
  // prop reactive member variables publically available to the html template
  @Prop({ default: false })
  public showBack: boolean

  @Prop({ default: null })
  public step: quizSteps

  @Prop({ default: null })
  public image: string

  @Prop({ default: null })
  public title: string

  @Prop({ default: null })
  public lineTexts: string[]

  @Prop({ default: null })
  public choices: string[]

  @Prop({ default: false })
  public allowMultiple: boolean

  @Prop({ default: null })
  public inputs: string[]

  @Prop({ default: false })
  public phoneInput: boolean

  @Prop({ default: false })
  public passwordInput: boolean

  @Prop({ default: -1 })
  public allowSkip: number

  // public reactive member variables available to the html template
  public showStuff: boolean = true

  public selectedChoices: string[] = []
  public inputedValues: string[] = []

  public phone: string = null;
  public fullPhoneNumber: string = null;
  public phoneNumberIsValid: boolean = null;

  public showSkip: boolean = false

  public password: string = null

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading; }
  public get user(): StoryUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }
  public get isAuthenticated(): StoryUser { return this.$store.getters.isAuthenticated }
  public get imageSource(): string { return `/images/quiz/${this.image}` }

  public buttonVariant(choice: string) { {
    return this.selectedChoices.includes(choice) ? 'success' : 'outline-success' }
  }

  public onPhoneUpdate(o: any) {
    this.fullPhoneNumber = o.e164
    this.phoneNumberIsValid = o.isValid
  }

  public reset() {
    this.selectedChoices = []
    this.inputedValues = []
    this.phone = null
    this.fullPhoneNumber = null
    this.phoneNumberIsValid = false
    this.password = null
    this.showSkip = false
  }

  public nextIsClickable(): boolean {
    if (this.choices && this.selectedChoices.length === 0) return false
    if (this.inputs) {
      const numInputFields: number = this.inputs.length
      for (let x = 0; x < numInputFields; x++) {
        if (!this.inputedValues[x] || this.inputedValues[x].trim().length === 0) return false
        // if (this.inputs[x].includes('email') && !utils.isValidEmail(this.inputedValues[x])) return false     // comment out because we noticed two folks early on who entered bad emails.  so let's catch that in onNext()
      }
    }
    if (this.phoneInput && !this.phoneNumberIsValid) return false
    if (this.passwordInput && !utils.isValidPassword(this.password)) return false

    return true
  }
  public async onSkip(): Promise<void> {
    this.$emit('userIndicatedSkipped', this.step);
    this.reset()
  }
  public async onBack(): Promise<void> {
    this.$emit('userIndicatedBack', this.step);
    this.reset()
  }
  public async onNext(): Promise<void> {
    // make sure fields are valid 
    if (this.inputs) {
      const numInputFields: number = this.inputs.length
      for (let x = 0; x < numInputFields; x++) {
        if (!this.inputedValues[x] || this.inputedValues[x].trim().length === 0) {
          utils.toast(this, 'Missing field', `Please enter ${this.inputs[x]}.`)
          return
        }
        if (this.inputs[x].includes('email') && !utils.isValidEmail(this.inputedValues[x])) {
          utils.toast(this, 'Invalid email', 'Please enter a valid email address.')
          return
        }
      }
    }
    if (this.phoneInput && !this.phoneNumberIsValid) {
      utils.toast(this, 'Invalid phone number', 'Please enter a phone number.')
      return
    }
    if (this.passwordInput && !utils.isValidPassword(this.password)) {
      utils.toast(this, 'Invalid password', 'Your password must be at least 4 characters.')
      return
    }


    const answers: string[] = this.selectedChoices.concat(this.inputedValues)
    if (this.phoneNumberIsValid) answers.push(this.fullPhoneNumber)
    this.$emit('userIndicatedDone', this.step, answers, this.password);
    this.reset()
  }
  public async onChoice(choice: string) {
    if (this.selectedChoices.includes(choice)) {
      this.selectedChoices = this.selectedChoices.filter((s) => s !== choice)
    } else {
      if (this.allowMultiple) this.selectedChoices.push(choice);
      else this.selectedChoices = [ choice ]

      // special case for step 'chooseLearningMethod'
      const utm_campaign: string = localStorage.getItem('utm_campaign')
      let readingType: 'storyTeller'|'champion' = 'champion'
      if (utm_campaign && utm_campaign.includes('champ')) readingType = 'champion'
      if (utm_campaign && utm_campaign.includes('listener')) readingType = 'champion'
      if (utm_campaign && utm_campaign.includes('elderly')) readingType = 'storyTeller'
      if (utm_campaign && utm_campaign.includes('storyteller')) readingType = 'storyTeller'

      if (this.step === 'chooseLearningMethod') {
        if (choice.toLocaleLowerCase().includes('video')) {
          (this.$refs.VideoComponent as any).show(null, 'lg', { video: 'whiteboard_keymanj'})     // TODO: show storyTeller video once we have one
        } else if (choice.toLocaleLowerCase().includes('reading')) {
          (this.$refs.ReadingComponent as any).show(null, 'lg', { type: readingType })
        }
      }

      if (!this.allowMultiple && this.selectedChoices.length > 0) {
        await utils.sleep(150)    // slight delay before proceeding so that button feedback can happen
        this.showStuff = false
        this.onNext()
        await utils.sleep(10)
        this.showStuff = true
      }
    }
  }

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async mounted() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    // @ts-ignore: because segment analytics is loaded in head script
    window.analytics.page(this.$options.name)
  }

  private async beforeUpdate() {
    if (this.allowSkip < 0) this.showSkip = false
    if (this.allowSkip >= 0 && !this.showSkip) {
      if (this.allowSkip > 0) await utils.sleep(this.allowSkip)
      this.showSkip = true
    }
  }

  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }




}
